import Network from 'infrastructure/js/modules/network';
import * as workOrdersService from '../../../services/WorkOrders/workOrdersService';
import {api as messageDialogApi} from '../../MessageDialog/messageDialogActions';
import { api as gridApi} from './workOrdersManagementGridActions';
import {createLabelHelper} from 'infrastructure/js/utils/labelHelper';
import PermissionManager from 'infrastructure/js/utils/permissionManager';


/////////////////////////////////////////
// ACTION TYPES - PUBLIC, FOR REDUCERS
export const actionTypes = {
};

////////////////////////////////////////////////////////////////
// PLAIN ACTION CREATORS - PRIVATE, FOR LOCAL DISPATCH ONLY
const actions = {
};

/////////////////////////////////////////////////////
// METHODS FOR JSX PROPS - PUBLIC, ALL THUNK TYPE
export let jsxActions = {};

jsxActions.reload = function () {
  return function (dispatch, getState) {
    gridApi.reload(dispatch, getState)();
  }
};

jsxActions.clearFilters = function () {
  return function (dispatch, getState) {
    gridApi.clearFilters(dispatch, getState)();
  }
};


jsxActions.removeWorkOrders = function(data) {
  return function(dispatch, getState) {
    api.removeWorkOrders(dispatch, getState)(data);
  }
};

jsxActions.removeAllWorkOrders = function(data) {
  return function(dispatch, getState) {
    api.removeAllWorkOrders(dispatch, getState)(data, true);
  }
};


/////////////////////////////////////////////////////////////////////////
// API METHODS - PUBLIC, FOR OTHER ACTION MODULES (and internal use)
export let api = {};

api.removeAllWorkOrders = function(dispatch, getState) {
  return function () {
    let labels = createLabelHelper('mat.administration.psmanagement.workOrdersManagement.view.');

    let orgName = PermissionManager.getLoggedInUser()?.loggedInOrg?.name || '';
    let confirmationConfig = {
      message: labels.get('removeAll.confirmation.message', '', {orgName}),
      cancelHandler: messageDialogApi.close(dispatch, getState),
      submitHandler: () => api.doRemoveAllWorkOrders(dispatch, getState)(),
    };

    messageDialogApi.showConfirmation(dispatch, getState)(confirmationConfig);
  }
};

api.doRemoveAllWorkOrders = function(dispatch, getState) {
  return function() {
    messageDialogApi.close(dispatch, getState)();

    workOrdersService.removeAllWorkOrders().then((response) => {
      if (!Network.isResponseValid(response)) {
        console.error('Failed to remove all work orders', response);
        messageDialogApi.responseError(dispatch, getState)(response);
        return {success: false};
      }
      gridApi.reload(dispatch, getState)();
    });
  }
};

api.removeWorkOrders = function(dispatch, getState) {
  return function (data) {
    let workOrderIds = data?.selectedRowsData?.map(item => item.id)?.toJS() || [];

    let labels = createLabelHelper('mat.administration.psmanagement.workOrdersManagement.view.');
    let confirmationConfig = {
      message: labels.get('remove.confirmation.message', '', {count: workOrderIds?.length ?? 0}),
      cancelHandler: messageDialogApi.close(dispatch, getState),
      submitHandler: () => api.doRemoveWorkOrders(dispatch, getState)({workOrderIds}, data.reloadParentComponent),
    };

    messageDialogApi.showConfirmation(dispatch, getState)(confirmationConfig);
  }
};

api.doRemoveWorkOrders = function(dispatch, getState) {
  return function(data, reloadParentComponent) {
    messageDialogApi.close(dispatch, getState)();

    workOrdersService.removeWorkOrders(data).then((response) => {
      if (!Network.isResponseValid(response)) {
        console.error('Failed to remove work orders', response);
        messageDialogApi.responseError(dispatch, getState)(response);
        return {success: false};
      }
      reloadParentComponent?.();
    });
  }
};


/////////////////////////////////////////////////////////////////////////
// PRIVATE HELPERS
